/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentFromJSON, DocumentToJSON, } from './Document';
/**
 * Check if a given object implements the ListDocumentsResponse interface.
 */
export function instanceOfListDocumentsResponse(value) {
    if (!('documents' in value) || value['documents'] === undefined)
        return false;
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
export function ListDocumentsResponseFromJSON(json) {
    return ListDocumentsResponseFromJSONTyped(json, false);
}
export function ListDocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'documents': (json['documents'].map(DocumentFromJSON)),
        'count': json['count'],
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}
export function ListDocumentsResponseToJSON(json) {
    return ListDocumentsResponseToJSONTyped(json, false);
}
export function ListDocumentsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'documents': (value['documents'].map(DocumentToJSON)),
        'count': value['count'],
        'nextToken': value['nextToken'],
    };
}
